import { EmptyState, FlexColumn, Loading } from '@gorila-shared-ui/components';
import { useEffect } from 'react';
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import { getAlarmsReportByGroup } from '../../../services/reportsService';
import { apiParamsState, isAllWorkspacesSelect } from '../../../storage/app';
import {
  loadingAlarmsState,
  reportAlarmFilterState,
  reportAlarmsState,
  reportAlarmsStates,
  reportEndDateState,
  reportFilterGroupState,
  reportStartDateState,
} from '../../../storage/reports';
import { HistoricAlarm } from '../../../types/currentState';
import AlarmsReportTable from './AlarmsReportTable';

function AlarmsReportsByGroup() {
  const { css } = useStyles();
  const groupId = useRecoilValue(reportFilterGroupState);
  const endDate = useRecoilValue(reportEndDateState);
  const startDate = useRecoilValue(reportStartDateState);
  const apiParams = useRecoilValue(apiParamsState);
  const [loadingAlarms, setLoadingAlarms] = useRecoilState(loadingAlarmsState);
  const setReportAlarms = useSetRecoilState(reportAlarmsStates);
  const resetReportAlarms = useResetRecoilState(reportAlarmsStates);
  const isAllWorkspacesSelected = useRecoilValue(isAllWorkspacesSelect);
  const states = useRecoilValue(reportAlarmsState(groupId));
  const alarmType = useRecoilValue(reportAlarmFilterState);

  useEffect(() => {
    return () => {
      resetReportAlarms();
    };
  }, []);

  useEffect(() => {
    if (!groupId || !startDate || !endDate || !apiParams) return;
    const loadAlarms = async () => {
      setLoadingAlarms(true);
      const { alarmsReports, error } = await getAlarmsReportByGroup(
        apiParams.clientId,
        groupId,
        startDate,
        endDate,
        isAllWorkspacesSelected ? undefined : apiParams.subClientId,
        alarmType,
      );
      const newHistorics: { [key: string]: HistoricAlarm[] } = {};
      if (!error) {
        newHistorics[groupId] = alarmsReports ?? [];
      }
      setReportAlarms(newHistorics);
      setLoadingAlarms(false);
    };
    loadAlarms();
  }, [groupId, startDate, endDate, apiParams, alarmType, isAllWorkspacesSelected]);

  if (loadingAlarms) {
    return <Loading />;
  }

  if (!groupId) {
    return <EmptyState title="Selecciona un grupo para visualizar el reporte." />;
  }

  return (
    <FlexColumn
      gap={0}
      classNames={css({ flex: 1, overflow: 'hidden' })}
    >
      <AlarmsReportTable
        states={states}
        extended
      />
    </FlexColumn>
  );
}

export default AlarmsReportsByGroup;
